/* eslint-disable formatjs/no-literal-string-in-jsx */
/* We are outside of the intl provider, so we cant use the translation service in that component */
import React from 'react'
import { RedoIcon } from '@slite/icons'
import { Layout, Main, Text, Button } from '.'

type UnhandledErrorProps = {
  error: Error
  superEnabled: boolean
}
export function UnhandledError({ error, superEnabled }: UnhandledErrorProps) {
  return (
    <Layout superEnabled={superEnabled}>
      <Main.Container>
        <Text.Title>Oops, something went wrong</Text.Title>
        <Text.Corpus className="shade-20 margin-vertical-16">
          Please try again. If the problem persists contact support
        </Text.Corpus>
        <div className="margin-vertical-16 border-shade-30 border-small padding-normal radius-normal">
          {error.message}
        </div>
        <div className="flexbox flexbox-justify-center">
          <Button
            variant="primary"
            className="margin-right-12"
            onClick={window.location.reload}
            icon={RedoIcon}
          >
            Try again
          </Button>
        </div>
      </Main.Container>
    </Layout>
  )
}
